/**
* A generalization of api Methods
* @return {Obiect}
*/
angular.module('mtic')
.service('apiMethods', function (
  $http,
  $q,
  $location,
  $log,
  EventManager,
  API_CONFIG,
  userAccount,
  API_ROUTES,
  Firebase,
  LoginCookie,
  $timeout,
  language,
  $interval
) {

  var eventManager = new EventManager('apiMethods')
  /**
  * API Path
  * @type {String}
  */
  //TODO  get rid of this
  var api_version = window.location.href.indexOf('pre-live') > -1 || window.location.href.indexOf('mathematic.lu') > -1 || window.location.href.indexOf('mathematic.org') > -1? API_CONFIG.API_VERSION : API_CONFIG.API_QC_VERSION;
  var API_PATH = API_CONFIG.REMOTE_API + api_version;
  var FEDERATION_API_PATH = API_CONFIG.REMOTE_API_FEDERATION;

  window.__clearSession = function(){
    apiMethods.setHeaders('U2FsdGVkX19RxUGEMDe/pznrh1hXJ7H5ER9SVEzQMMepbG3LlBaqUinXXNUDopKx', authHeaders['X-Auth-Id']);
  }

  var cached_promise;
  var resubmission_call_urls = [API_PATH+'/student/resource/state']
  /**
  * Default Authorization headers
  * @type {Object}
  */
  var authHeaders;
  var federationHeaders = {};
  var resetHeaders = function () {
    authHeaders = {};
    federationHeaders = {};
  }
  resetHeaders()
  var callThrottle = {};

  /**
  * On Sucess of an api call
  * @param  {Object} response
  * @param  {String} pathName
  * @param  {$q.resolve} resolve
  * @param  {$q.resolve} reject
  * @return {Null}
  */
  var successResults = function (response, pathName, resolve, reject) {
    if (response.data.success) {
      LoginCookie.refreshCookieStore();
      resolve(response.data.data)
      callThrottle[pathName] = false;
    } else {
      $log.error({
        call: pathName,
        error: response.data.data
      })
      reject(response.data)
      callThrottle[pathName] = false;
    }
  }
  /**
  * In the case of a failed results run this
  * This will attempt to re-submit the api call in a failed instance
  * @param  {$http.Request} apiCall
  * @param  {String} pathName
  * @param  {Object} response
  * @param  {$q.resolve} resolve
  * @param  {$q.reject} reject
  * @return {null}
  */
  var failedResults = function (apiCall, pathName, response, resolve, reject) {
    try {
      if(!response.data){
        reject('FAILED_TO_CONNECT')

        callThrottle[pathName] = false;
        $log.error(response);

      }
      else if (response.data.message === 'SESSION_EXPIRED') {
        userAccount.expireSession();
        var listenerExpiry = eventManager.listen('session-expiry:close', function () {
          apiCall.headers = authHeaders;
          apiCall.headers["Content-Type"] = "application/json;charset=utf-8";
          listenerExpiry();
          listenerLogout();
          $http(apiCall).then(function (response) {
            callThrottle[pathName] = false;
            successResults(response, pathName, resolve, reject)
          }).catch(function (response) {
            failedResults(apiCall, pathName, response, resolve, reject)
          })
        })
        var listenerLogout = eventManager.listen('logout', function () {
          listenerExpiry();
          listenerLogout();
        })
      }
      else if (response.data.message === 'ERROR_TOKENEXPIREDERROR' || response.data === 'EXPIRED_TOKEN') {
        apiMethods.FEDERATION_GET("REFRESH_TOKEN", {}, federationHeaders)
        .then(function (new_token) {
          if(!new_token){       
            eventManager.broadcast('refresh-token-expired');
            reject(response.data);
          } else{            
            authHeaders['X-ACCESS-TOKEN'] = new_token;
            apiCall.headers['X-ACCESS-TOKEN'] = new_token;
            $http(apiCall).then(function (response) {
              callThrottle[pathName] = false;
              successResults(response, pathName, resolve, reject)
            }).catch(function (response) {
              failedResults(apiCall, pathName, response, resolve, reject)
            })
          }
        }).catch(function(err){
          $log.error(err);          
          reject(response.data);
          eventManager.broadcast('refresh-token-expired');
        })
      }
      else {
        $log.error(response);
        callThrottle[pathName] = false;
        reject(response.data)
      }
    } catch (err) {
      $log.error("An issue occured for", pathName)
      $log.error(apiCall)
      $log.error(response)
      $log.error(err.message)
      $log.error(err.stack)
      callThrottle[pathName] = false;
      reject(err.message)
    }
  }
  /**
  * Every call is wrapped with this method
  * @param  {$http.Request} apiCall
  * @param  {String} pathName
  * @return {Promise}
  */
    var cached_promises = [];
    window.setInterval(function(){
      if(!navigator.onLine){
        eventManager.broadcast('offline-post-call');
      }
    }, 1000)
    var checkStatus = function(resolve){
      if(navigator.onLine){
        //resolve()
        cached_promises.forEach(function(pr){
          pr();
        })
        cached_promises = [];
        eventManager.broadcast('offline-post-call-resolved');
      }else{
        eventManager.broadcast('offline-post-call');
      }
    }
   var waitForNetworkConnection = function(){
    //  $log.log('CHECKING LIST : ', cached_promises)
    return $q(function(resolve, reject){
      //cached_promise = resolve;
      cached_promises.push(resolve);
    })
   }
  var afterCallWrapper = function (apiCall, pathName) {
    // $log.log("AFTER CALL WRAPPER : ", apiCall, pathName)
    $log.debug('[[API CALL]]', pathName)
    // if (callThrottle[pathName]) {
    //       throw pathName + ' is being sent too rapidly!'
    // } else {
    //       callThrottle[pathName] = true;
    apiCall.headers = angular.extend(
      angular.copy(authHeaders),
      apiCall.headers
    )
    apiCall.headers["Content-Type"] = "application/json;charset=utf-8";
    //added this part to deal with offline submissions

    function tryAgain(){
      return $q(function (resolve, reject) {
        $http(apiCall).then(function (response) {
          callThrottle[pathName] = false;
          successResults(response, pathName, resolve, reject)
        }).catch(function (response) {
            if(!navigator.onLine || !response.data){
              eventManager.broadcast('offline-post-call');
              return waitForNetworkConnection().then(function(){
                return tryAgain().then(function(response){
                  resolve(response)
                })
              })

            }else{
              failedResults(apiCall, pathName, response, resolve, reject)
            }

        })
      });
    }
    return tryAgain()
    


  }

  /**
  * Public Methods
  * @type {Object}
  */
  var apiMethods = {
    /**
    * Generalized PUT call
    * @param {String} pathName
    * @param {Object} body
    * @param {Object} query
    * @param {String} string_query
    */
    POST: function (pathName, body, query, headers) {
      return afterCallWrapper({
        method: 'POST',
        url: API_PATH + API_ROUTES.POST[pathName],
        data: body,
        params: query,
        headers: angular.extend(authHeaders,headers||{})
      }, 'POST ' + pathName);
    },
    /**
    * Generalized PUT call
    * @param {String} pathName
    * @param {Object} body
    * @param {Object} query
    */
    PUT: function (pathName, body, options) {
      options = options || {}
      return afterCallWrapper({
        method: 'PUT',
        url: API_PATH + API_ROUTES.PUT[pathName],
        data: body,
        params: options.query,
        headers: angular.extend(authHeaders,options.headers||{})
      }, 'PUT ' + pathName);
    },
    /**
    * Generalized DELETE call
    * @param {String} pathName
    * @param {Object} body
    * @param {Object} query
    */
    DELETE: function (pathName, body, query) {
      return afterCallWrapper({
        method: 'DELETE',
        url: API_PATH + API_ROUTES.DELETE[pathName],
        data: body,
        params: query,
        headers: authHeaders
      }, 'DELETE ' + pathName);
    },
    /**
    * Generalized GET call
    * @param {String} pathName
    * @param {Object} query
    */
    GET: function (pathName, query, headers) {
      return afterCallWrapper({
        method: 'GET',
        url: API_PATH + API_ROUTES.GET[pathName],
        params: query,
        headers: angular.extend(authHeaders,headers||{})
      }, 'GET ' + pathName);
    },
    FEDERATION_GET: function (pathName, query, headers) {
      return afterCallWrapper({
        method: 'GET',
        url: FEDERATION_API_PATH + API_ROUTES.GET[pathName],
        params: query,
        headers: angular.extend(_.clone(authHeaders),headers||{})
      }, 'GET ' + pathName);
    },
    setHeaders: function (sessionKey, authId, access_token, refresh_token) {
      authHeaders['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
      authHeaders['Cache-Control'] = 'no-cache';
      authHeaders.Pragma = 'no-cache';

      authHeaders['X-Auth-Session-Key'] = String(sessionKey);
      authHeaders['X-Auth-Id'] = String(authId);
      if(access_token && refresh_token){
        authHeaders['X-ACCESS-TOKEN'] = access_token;
        federationHeaders['X-REFRESH-TOKEN'] = refresh_token;
      }
      eventManager.setHeaders(authHeaders)
    },
    setGroupId: function (groupId) {
      authHeaders['X-Group-Id'] = String(groupId);
      eventManager.setHeaders(authHeaders)
    },
    getAuthHeaders(){
      return authHeaders;
    },
    loginAs: function({user_id, uuid}){
      return apiMethods.POST("USER_LOGIN_AS", {
        "user_id": parseInt(user_id),
        "uuid": uuid
      })
      .then(function (response) {
        if(response.user_id){
          // console.log('LOGIN AS success: ', response)
          apiMethods.setHeaders(response.session_key, response.user_id, response.access_token, response.refresh_token);

          var userRole = userAccount.setData(uuid, response);
          apiMethods.setGroupId(userRole.group_id)
          return Firebase.auth().signInWithCustomToken(response.firebaseToken).then(function(){
            eventManager.broadcast('login:first');
            eventManager.broadcast('login:login_as');
          })
        }
      })
    },
    /**
    * The user login function
    * @param  {String} uuid
    * @param  {String} password
    * @return {Promise}
    */
    login: function ({uuid, password, auth_type='localStrategy', dueToExpiry, keepMoving, dontCatch}) {

      var loginPromise = apiMethods.POST("USER_LOGIN", {
        uuid,
        "secret_key": password,
        auth_type
      })
      .then(function (response) {
        var userData = response;
        if (userData.user_id) {
          apiMethods.setHeaders(userData.session_key, userData.user_id, userData.access_token, userData.refresh_token);
          var userRole = userAccount.setData(uuid, userData);
          // $log.log('window.isWebEmbedConnect', window.isWebEmbedConnect)
          // if (window.isWebEmbedConnect){
          //   window.location.href = window.location.href+'&web-embed-response&user_id='+userData.user_id+'&session_key='+userData.session_key+'&group_id='+userRole.group_id;
          // }
          apiMethods.setGroupId(userRole.group_id)
          return Firebase.auth().signInWithCustomToken(userData.firebaseToken)
        }
        else {
          eventManager.broadcast('login:fail', 'MISSING_USER_ID')
        }
      })
      .then(function(){
        if (dueToExpiry) {
          eventManager.broadcast('login:session-refresh')
          if(keepMoving) {
            eventManager.broadcast('login:first')
          }
        } else {
          eventManager.broadcast('login:first')
        }
      })
      if(dontCatch) {
        return loginPromise;
      }
      else{
        return loginPromise.catch(function (error) {
          $log.debug('[[apiMethods]] login:fail', error)
          eventManager.broadcast('login:fail', error.message)
        })
      }

    },
    /**
    * Restores login-session
    * @param  {Intger} userId
    * @param  {String} sessionKey
    * @param  {Integer} groupId
    * @return {Promise}
    */
    loginRestore: function (uuid, userId, sessionKey, firebaseToken, fromAutoLogin) {
      return apiMethods.GET("USER_LOGIN", {}, {
        "X-Auth-Id": userId,
        "X-Auth-Session-Key": sessionKey
      })
      .then(function (response) {
        var userData = {
          user_id: userId,
          session_key: sessionKey,
          roles: response[0].roles,
          info: response[0].info,
          firebaseToken: firebaseToken,
        };
        apiMethods.setHeaders(sessionKey, userId, response[0].access_token, response[0].refresh_token)
        var userRole = userAccount.setData(uuid, userData);
        apiMethods.setGroupId(userRole.group_id);
        return Firebase.auth().signInWithCustomToken(firebaseToken);
      })
      .then(function(){
        eventManager.broadcast('login:first')
      })
      .catch(function (error) {
        $log.debug('[[apiMethods]] login:fail', error)
        if(error.message === "TOKEN_EXPIRED" && fromAutoLogin){
          eventManager.broadcast('login:first')
        } else if (error.code === "auth/invalid-custom-token") {
          eventManager.broadcast('token-expired-logout');
        }
      })
    },
    /**
    * Resets all credentials
    * @return {String}
    */
    logout: function () {
      resetHeaders()
      userAccount.logout()
    },
    resubmitOfflinePost: function(){
      $timeout(function(){
        checkStatus(cached_promise);
      }, 200)
    }
  }
  return apiMethods;
});
